goog.require('el8.template.multiuser_access.locateAccount');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }





el8.multiuser_access.locateAccount = (function() {

    var that = {};
    var theForm = null;

    function locateMyAccount() {
        // signup and go to chart


        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('submitLocator'),
            data: JSON.stringify({
                lastName: theForm.getVal('lastName'),
                fax: theForm.getVal('fax')
            }),
            async: true,
            success: function(data) {
                if (data.location) {
                    location.href=data.location;
                } else if (data.error) {

                    $('.el8ErrorAlert').show();
                } else {

                    $('.account-chooser-container').html(
                        el8.template.multiuser_access.locateAccount.accountChooser({
                           accounts: data
                        })
                    );
                }
            }
        });
    }


    function inputChanged() {
        var lastName = theForm.getVal('lastName');
        var fax = theForm.getVal('fax');

        if (fax && lastName) {
            $('#locate-my-account').prop('disabled', false);
        } else {
            $('#locate-my-account').prop('disabled', true);
        }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function setupKeyPressedListeners() {
        $(document).on(
            "keypress",
            ':input[name="lastName"], :input[name="fax"]',
            debouncedInputChanged
        );
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */


        if (spec.urls) { el8.service.urls.init(spec.urls); }


        $('.main-content').html(
            el8.template.multiuser_access.locateAccount.content({})
        );


        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'lastName',
                selector: ':input[name="lastName"]',
                maxLength: 30,
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'fax',
                selector: ':input[name="fax"]',
                maxLength: 12,
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();

        inputChanged();

        $(':input[name="lastName"]').focus();

        $('.el8ErrorAlert').hide();

        setupKeyPressedListeners();

        $(document).on('click', '#locate-my-account', function(event) {
            locateMyAccount();
        });


    };

    return that;

})();